import user_01 from './user-01.svg';
import user_02 from './user-02.svg';
import user_03 from './user-03.svg';
import user_add from './user-add.svg';
import user_card_id from './user-card_id.svg';
import user_check from './user-check.svg';
import user_circle from './user-circle.svg';
import user_close from './user-close.svg';
import user_group from './user-group.svg';
import user_remove from './user-remove.svg';
import user_square from './user-square.svg';
import user_users from './user-users.svg';
import user_voice from './user-voice.svg';

export const V2_USER_ICONS: { [char: string]: string } = {
  user_01,
  user_02,
  user_03,
  user_add,
  user_card_id,
  user_check,
  user_circle,
  user_close,
  user_group,
  user_remove,
  user_square,
  user_users,
  user_voice,
};

export const V2_USER_ICON_NAMES: string[] = Object.keys(V2_USER_ICONS);
